/* Villain Magazine — shared page behaviour: reveals, mobile menu, event slides, manifesto reading effect. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // header height feeds the pinned hero (it sits just under the sticky header)
  const header = document.querySelector('.site-header');
  const setHH = () => document.documentElement.style.setProperty('--hh', header.offsetHeight + 'px');
  setHH();
  window.addEventListener('resize', setHH);

  // mobile menu
  const menuBtn = document.querySelector('.menu-btn');
  if (menuBtn) menuBtn.addEventListener('click', () => {
    const open = header.classList.toggle('menu-open');
    menuBtn.setAttribute('aria-expanded', open);
    menuBtn.textContent = open ? 'Close' : 'Menu';
  });

  // event covers: cycle through the night's frames on hover (desktop) or tap (touch)
  document.querySelectorAll('[data-slides]').forEach((box) => {
    const imgs = box.querySelectorAll('img');
    const count = box.querySelector('.event-count b');
    let i = 0, timer = null;
    imgs[0].classList.add('on');
    const show = (n) => {
      imgs[i].classList.remove('on');
      i = (n + imgs.length) % imgs.length;
      imgs[i].classList.add('on');
      if (count) count.textContent = i + 1;
    };
    box.addEventListener('click', () => show(i + 1));
    if (reduce) return;
    box.addEventListener('mouseenter', () => { show(i + 1); timer = setInterval(() => show(i + 1), 1100); });
    box.addEventListener('mouseleave', () => { clearInterval(timer); });
  });

  // manifesto: words light up as the statement is read, then the redaction lifts
  const statement = document.querySelector('[data-read]');
  if (!statement || reduce || !window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const wrapWords = (node) => {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === 3) {
        const frag = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          const w = document.createElement('span');
          w.className = 'w'; w.textContent = part;
          frag.appendChild(w);
        });
        child.replaceWith(frag);
      } else if (child.nodeType === 1 && !child.classList.contains('redact')) {
        wrapWords(child);
      } else if (child.nodeType === 1) {
        child.classList.add('w');
      }
    });
  };
  wrapWords(statement);
  const words = statement.querySelectorAll('.w');
  const redact = statement.querySelector('.redact');

  const tl = gsap.timeline({
    scrollTrigger: { trigger: statement, start: 'top 78%', end: 'bottom 38%', scrub: 0.6 },
  });
  tl.to(words, { opacity: 1, stagger: 0.08, duration: 0.3, ease: 'none' });
  if (redact) tl.to(redact, { '--r': 0, duration: 0.6, ease: 'power2.inOut' }, '-=0.2');
})();
